import * as React from 'react';
import * as styles from './styles.css';

export interface ILinkButtonProps {
  children: React.ReactNode;
  onClick(e: React.MouseEvent<HTMLElement>): void;
}

export function ButtonLink({ children, onClick }: ILinkButtonProps): React.JSX.Element {
  return (
    <button className={styles['link']} onClick={onClick}>
      {children}
    </button>
  );
}
